"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputNumber = exports.Textarea = exports.InputSearch = exports.InputPassword = exports.Input = void 0;
var _react = _interopRequireWildcard(require("react"));
var _input = _interopRequireDefault(require("antd/es/input"));
var _inputNumber = _interopRequireDefault(require("antd/es/input-number"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icons = require("../Icons");
var _Button = require("../Button");
require("./style.sass");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// eslint-disable-next-line react/display-name
var Input = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var mainClassNames = (0, _classnames.default)('sber-input', props.className);
  return /*#__PURE__*/_react.default.createElement(_input.default, _extends({}, props, {
    className: mainClassNames,
    ref: ref
  }));
});
exports.Input = Input;
var Password = _input.default.Password; // eslint-disable-next-line react/display-name

var InputPassword = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var className = props.className,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? -1 : _props$tabIndex;
  var mainClassNames = (0, _classnames.default)('sber-input sber-input-password', className);
  return /*#__PURE__*/_react.default.createElement(Password, _extends({}, props, {
    tabIndex: tabIndex,
    className: mainClassNames,
    ref: ref,
    iconRender: function iconRender() {
      return /*#__PURE__*/_react.default.createElement(_Button.Button, {
        text: true,
        type: "button",
        style: {
          height: 16,
          lineHeight: 1
        }
      }, /*#__PURE__*/_react.default.createElement(_Icons.ShowIcon, {
        size: 16,
        color: "#878B90"
      }));
    }
  }));
});
exports.InputPassword = InputPassword;
var Search = _input.default.Search; // eslint-disable-next-line react/display-name

var InputSearch = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var mainClassNames = (0, _classnames.default)('sber-input sber-input-search', props.className);
  return /*#__PURE__*/_react.default.createElement(Search, _extends({}, props, {
    ref: ref,
    className: mainClassNames,
    enterButton: /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      style: {
        height: 16,
        lineHeight: 1
      }
    }, /*#__PURE__*/_react.default.createElement(_Icons.SearchIcon, {
      size: 16,
      color: "#21A038"
    }))
  }));
});
exports.InputSearch = InputSearch;
var AntTextArea = _input.default.TextArea; // eslint-disable-next-line react/display-name

var Textarea = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var mainClassNames = (0, _classnames.default)('sber-input sber-textarea', props.className);
  return /*#__PURE__*/_react.default.createElement(AntTextArea, _extends({}, props, {
    ref: ref,
    className: mainClassNames
  }));
});
exports.Textarea = Textarea;
var InputNumber = function InputNumber(props) {
  var mainClassNames = (0, _classnames.default)('sber-input sber-input-number', props.className);
  return /*#__PURE__*/_react.default.createElement(_inputNumber.default, _extends({}, props, {
    className: mainClassNames
  }));
};
exports.InputNumber = InputNumber;